import { enumUtil } from '@/utils';

const StatusEnumerator = {
  Apagado: new enumUtil.EnumBase(-1, 'Apagado'),
  Ativo: new enumUtil.EnumBase(0, 'Ativo'),
  Sincronizado: new enumUtil.EnumBase(1, 'Sincronizado'),
  AlteradoServidor: new enumUtil.EnumBase(2, 'AlteradoServidor'),
};

const TipoDataEnumerator = Object.freeze({
  Data: new enumUtil.EnumBase(1, 'Data'),
  DataHora: new enumUtil.EnumBase(2, 'Data e hora'),
  DataHoraEfetivado: new enumUtil.EnumBase(3, 'Data e hora efetivado'),
});

const TakePaginationEnumerator = Object.freeze({
  10: new enumUtil.EnumBase(10, '10'),
  25: new enumUtil.EnumBase(25, '25'),
  50: new enumUtil.EnumBase(50, '50'),
  75: new enumUtil.EnumBase(75, '75'),
  100: new enumUtil.EnumBase(100, '100'),
});

const UfsEnumerator = Object.freeze({
  AC: new enumUtil.EnumBase('AC', 'AC'),
  AL: new enumUtil.EnumBase('AL', 'AL'),
  AM: new enumUtil.EnumBase('AM', 'AM'),
  AP: new enumUtil.EnumBase('AP', 'AP'),
  BA: new enumUtil.EnumBase('BA', 'BA'),
  CE: new enumUtil.EnumBase('CE', 'CE'),
  DF: new enumUtil.EnumBase('DF', 'DF'),
  ES: new enumUtil.EnumBase('ES', 'ES'),
  GO: new enumUtil.EnumBase('GO', 'GO'),
  MA: new enumUtil.EnumBase('MA', 'MA'),
  MG: new enumUtil.EnumBase('MG', 'MG'),
  MS: new enumUtil.EnumBase('MS', 'MS'),
  MT: new enumUtil.EnumBase('MT', 'MT'),
  PA: new enumUtil.EnumBase('PA', 'PA'),
  PB: new enumUtil.EnumBase('PB', 'PB'),
  PE: new enumUtil.EnumBase('PE', 'PE'),
  PI: new enumUtil.EnumBase('PI', 'PI'),
  PR: new enumUtil.EnumBase('PR', 'PR'),
  RJ: new enumUtil.EnumBase('RJ', 'RJ'),
  RN: new enumUtil.EnumBase('RN', 'RN'),
  RO: new enumUtil.EnumBase('RO', 'RO'),
  RR: new enumUtil.EnumBase('RR', 'RR'),
  RS: new enumUtil.EnumBase('RS', 'RS'),
  SC: new enumUtil.EnumBase('SC', 'SC'),
  SE: new enumUtil.EnumBase('SE', 'SE'),
  SP: new enumUtil.EnumBase('SP', 'SP'),
  TO: new enumUtil.EnumBase('TO', 'TO'),
  EX: new enumUtil.EnumBase('EX', 'EX'),
});

export { StatusEnumerator, TipoDataEnumerator, TakePaginationEnumerator, UfsEnumerator };
